module.exports = "https://www.gc-pro.gnp.com.mx/e776146cfa681f3a10df478b53bfc4ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/acceso-compartido/06.png
// module id = 1000
// module chunks = 0 1